import React, { useEffect, useState } from 'react';
import { IoMdCreate } from 'react-icons/io';
import { IoIosCheckmark } from "react-icons/io";
import { IoIosAdd } from "react-icons/io";
import { IoIosClose } from "react-icons/io";
import { Api } from '../../../../services/api';
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';

const CoreFocus = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [formData, setFormData] = useState({
        corefocus: [
            {
                mainTitle: "",
                description: "",
            },
        ],
    });

    useEffect(() => {
        fetchData();
        const adminStatus = localStorage.getItem('isAdmin');
        setIsAdmin(adminStatus === 'Y');
    }, []);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(Api.API_BASE_URL + 'business-core/vision/core-focus/get', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : '',
                },
            });
            const data = await response.json();
            if (Array.isArray(data.result)) {
                const mappedData = data.result.map(item => ({
                    mainTitle: item.core_value || '',
                    description: item.description || ''
                }));
                setFormData({ corefocus: mappedData.length > 0 ? mappedData : [{ mainTitle: '', description: '' }] });
            } else {
                setFormData({ corefocus: [{ mainTitle: '', description: '' }] });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleSave = async () => {
        setIsEditing(false);
        try {
            const token = localStorage.getItem('authToken');
            const payload = {
                core_focus: formData.corefocus
            };

            const response = await fetch(Api.API_BASE_URL + 'business-core/vision/core-focus/save', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : ''
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            console.log('Data saved successfully:', result);
        } catch (error) {
            console.error('Error saving data:', error);
        }
    };

    const handleInputChange = (e, field, index) => {
        const newCoreFocus = [...formData.corefocus];
        newCoreFocus[index][field] = e.target.value;
        setFormData({
            ...formData,
            corefocus: newCoreFocus,
        });
    };

    const addRowCoreFocus = () => {
        setFormData({
            ...formData,
            corefocus: [
                { mainTitle: '', description: '' }, // Add new row with empty values
                ...formData.corefocus,
            ],
        });
    };

    const handleDelete = (index) => {
        const newCoreFocus = [...formData.corefocus];
        newCoreFocus.splice(index, 1);
        setFormData({
            ...formData,
            corefocus: newCoreFocus,
        });
    };

    const handleEditToggle = () => {
        if (isEditing) {
            handleSave();
        } else {
            setIsEditing(true);
        }
    };

    // TODO---------------------------
    const textareaStyle = {
        width: '90%',
        height: "40px",
        boxSizing: 'border-box',
        outline: 'none',
        fontSize: '16px',
        color: '#495057',
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        // border: 'none',
        // borderBottom: '1px solid #ccc',
        border: '1px solid #ccc',
    };
    // TODO---------------------------

    return (
        <div className="box2">
            <div className="box-header">
                <h4 className='title-font'>Core Focus™</h4>

                {isAdmin && (
                    <div onClick={handleEditToggle} style={{ cursor: 'pointer' }}>
                        {isEditing ? (
                            <IoIosCheckmark style={{ fontSize: '40px' }} />
                        ) : (
                            <IoMdCreate style={{ fontSize: '20px' }} />
                        )}
                    </div>
                )}
            </div>

            <div className="box-body" >
                {isEditing ? (
                    <>
                        {formData.corefocus.map((field, index) => (
                            <div
                                key={index}
                                style={{
                                    marginTop: '10px',
                                    alignItems: 'center',
                                }}
                            >
                                {/* Title Input Field */}
                                <div style={{ flex: 1 }}>
                                    <label htmlFor={`title-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
                                        Core Focus*
                                    </label>

                                    <div className='flex'>
                                        <InputTextarea
                                            id={`title-${index}`}
                                            type="text"
                                            autoResize
                                            value={field.mainTitle}
                                            onChange={(e) => handleInputChange(e, 'mainTitle', index)}
                                            // rows={2}
                                            className='s'
                                            style={textareaStyle}
                                        />
                                        {/* Add/Save and Delete Icons */}
                                        {index > 0 ? (
                                            <IoIosClose
                                                onClick={() => handleDelete(index)}
                                                style={{
                                                    fontSize: '40px',
                                                    cursor: 'pointer',
                                                    color: 'red',
                                                }}
                                            />
                                        ) : (
                                            <>
                                                <IoIosAdd
                                                    onClick={addRowCoreFocus}
                                                    style={{
                                                        fontSize: '40px',
                                                        cursor: 'pointer',
                                                    }}
                                                />

                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Description Textarea Field */}
                                <div style={{ flex: 2, marginTop: '10px' }}>
                                    <label htmlFor={`description-${index}`} style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '400' }}>
                                        Description*
                                    </label>
                                     <Editor
                                        id={`description-${index}`}
                                        value={field.description}
                                        onTextChange={(e) => handleInputChange({ target: { value: e.htmlValue } }, 'description', index)}
                                        style={{ height: '220px', width: '100%' }}
                                    />
                                </div>
                            </div>
                        ))}
                    </>
                ) : (
                    formData.corefocus.map((field, index) => (
                        <div className='row' key={index} style={{
                            padding: '2px 2px',
                            // marginTop: '5px',
                            borderRadius: '5px',
                            display: 'flex',
                        }}>
                            <div className='col-12 p-0'>
                                <h4 className='mb-2'>{field.mainTitle}</h4>
                                <div className='mb-3' dangerouslySetInnerHTML={{ __html: field.description }} />
                            </div>

                            {isEditing && (
                                <IoIosClose
                                    onClick={() => handleDelete(index)}
                                    style={{
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        color: 'red',
                                    }}
                                />
                            )}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default CoreFocus;
